import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { RoleTypeCIF } from '../../../shared/viewmodels/RegUtility';

@Component({
  selector: 'app-role-type',
  templateUrl: './role-type.component.html',
  styleUrls: ['./role-type.component.css']
})
export class RoleTypeComponent implements OnInit {

  public utilityobj: RoleTypeCIF;
  message: any;
  constructor(private store: Store<AppState>) {
    this.utilityobj = new RoleTypeCIF();
    this.store.select(getRegSearchState).subscribe(data => this.message = data);
    //console.log(this.message.role[0]);
    if (this.message.roletype.length != 0) {
      this.utilityobj.roleID = this.message.roletype[0].roleID;
      console.log(this.message.roletype[0]);
    } else {
      this.utilityobj.roleID = 1;
    }
  }

  ngOnInit() {
  }
}
